import "babel-polyfill";
import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import awsconfig from "./aws-exports";
import vuetify from "./plugins/vuetify";
import "@mdi/font/css/materialdesignicons.css";

Amplify.configure({
  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: "eu-west-2:f49bffc9-84d2-4f7f-8a37-e2f0a750487c",

    // REQUIRED - Amazon Cognito Region
    region: "eu-west-2",

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: "eu-west-2_2HVDIm7Ho",

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: "6rq15a8q7ofmqd9m8b0a943f6h",

    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  },
  Storage: {
    AWSS3: {
      bucket: "hp-internal-document-storage",
      region: "eu-west-2",
    },
  },
  API: {
    endpoints: [
      {
        name: "hpManageUserApi",
        endpoint: "https://l1qepgvg1b.execute-api.eu-west-2.amazonaws.com/master",
        region: "eu-west-2"
      }
    ]
  }
});

Amplify.configure(awsconfig);

Vue.config.productionTip = false;

Vue.use(AmplifyPlugin, AmplifyModules);

Vue.use(require("vue-moment"));

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
